<template>
  <div class="main-wrap" v-if="checkPermission()">
    <div id="main-content">
      <div class="wrapper">
        <jm-crumbs/>
        <div class="offer manage">
          <div class="options">
            <el-form
              :model="searchData"
              inline>

              <el-form-item label="渠道来源">
                <jm-channel
                  v-if="isFibSite"
                  v-model="searchData.channels"
                  :is-all="true"
                  :final.sync="channelFinal"
                  clearable
                  ref="channelRef"
                  filterable/>
              </el-form-item>
            </el-form>
          </div>
          <div class="operation">
            <el-button
              type="primary"
              @click="getSearch">查询</el-button>
            <el-button
              type="success"
              @click="exportExcel()">导出</el-button>
          </div>
          <jm-tableList
            url="/index/general_activity/brand"
            :refresh="refresh"
            :search-data="searchData"
            :current-page.sync="currentPage">
            <el-table-column
              slot="lastColumn"
              label="操作"
              width="260"
              align="center"
              fixed="right">
              <template slot-scope="scope">
                <el-button
                  type="danger"
                  size="mini"
                  v-if="scope.row.is_send === 0"
                  @click="toogleStatus(scope.row)"
                  icon="el-icon-edit-outline">{{
                    scope.row.is_send === 0 ? '发送' : ''
                  }}
                </el-button>
              </template>
            </el-table-column>
          </jm-tableList>
        </div>
      </div>
    </div>
  </div>
</template>
<style>

  .el-form {
    margin-top: 20px;
  }
  .button-search {
    margin-right: 10px;
    display: inline-block;
    height: 100%;
  }
  .offer.manage .operation {
    padding-bottom: 1em;
    text-align: center;
  }
  .offer.manage .options .el-form-item {
    display: -webkit-flex;
    display: flex;
    margin-bottom: 10px;
  }

  .offer.manage .options .el-form-item__label {
    min-width: 7em;
    padding-right: 8px;
  }
  .offer.manage .options .el-form-item__content {
    -webkit-flex: 1;
    flex: 1;
  }
  .offer.manage .options .el-date-editor--daterange.el-input,
  .offer.manage .options .el-date-editor--daterange.el-input__inner,
  .offer.manage .options .el-date-editor--timerange.el-input,
  .offer.manage .options .el-date-editor--timerange.el-input__inner {
    width: 100%;
    white-space: nowrap;
  }
</style>
<script>
import { mapGetters } from 'vuex';
import jmToolbar from '@/components/tool/toolbar';
import jmTableList from '@/components/data/tableList';
import { jmDictSelect, jmChannel } from '@/components/tool';
import { filterVisible } from '@/utils/utils';
import jmFormOptions from '@/components/data/formOptions';

// options
const options = {
};

export default {
  components: {
    jmToolbar, jmTableList, jmDictSelect, jmFormOptions, jmChannel
  },
  data() {
    return {
      options,
      searchData: {},
      currentPage: 1,
      urlPrefix: '',
      channelFinal: false,
      exporting: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 监听状态刷新数据
    refresh() {
      return this.$store.state.student.refresh;
    },
  },
  methods: {
    filterVisible,
    getSearch() {
      this.currentPage = 1;
      this.searchData.isSearch = false;
      Object.values(this.searchData).forEach((item) => {
        if (item) {
          this.searchData.isSearch = true;
        }
      });
      this.$store.commit('updateRefresh', true);
    },
    toogleStatus (row) {
      this.$http._post({
        url: '/index/general_activity/updateBrandById',
        data: { id: row.id }
      }).then(() => {
        this.getSearch();
      });
    },
    checkPermission() {
      if (this.$hasPermission([154]) && !this.$hasPermission([1])) {
        if (this.userInfo.userid === 251652) {
          return true;
        }
        return false;
      }
      return true;
    },
    exportExcel() {
      this.exporting = true;
      this.$http._post({
        url: '/index/general_activity/exportExcel',
        data: this.searchData,
      }).then(({ data }) => {
        this.exporting = false;
        this.$http._download({
          filename: data,
          download: '博物馆礼物领取列表.xlsx'
        });
      }).catch((data) => {
        if (typeof data.data !== 'undefined' && data.data.result === -1) {
          this.$message.error(data.data.data);
        } else {
          this.$message.error('服务异常');
        }
        this.exporting = false;
      });
    }
  },
  created() {
  },
  watch: {
  }
};
</script>
